import { ApiResponse } from 'apisauce';

import { IApprovalGateway } from './approvalBase';

import UtilFunctions from '~utils/functions';
import { TUpdateBranchStatusAPIParams, TUpdateCollateralStatusAPIParams, TUpdateCustomerTransferStatusAPIParams, TUpdateDiscountStatusAPIParams, TUpdateEarmarkConversionStatusAPIParams, TUpdateGoldConversionStatusAPIParams, TUpdateInventoryTransactionStatusAPIParams, TUpdateInventoryTransferStatusAPIParams, TUpdateProductStatusAPIParams, TUpdateProjectStatusAPIParams, TUpdateReleaseEarmarkAPIParams, TUpdateStockOutStatusAPIParams, TUpdateTransactionStatusAPIParams } from '~types/feat/approval';
import { GatewayResponse } from '~types/gateway';

const { API: { getHeaders } } = UtilFunctions;
export default class ApprovalGateway extends IApprovalGateway {
    async updateTransactionStatus(params: TUpdateTransactionStatusAPIParams): GatewayResponse<null> {
        const { authToken, ...restOfUpdateTransactionStatusAPIParams } = params;
        const response: ApiResponse<null> = await this.api.put('/approval/updateTransactionStatus', restOfUpdateTransactionStatusAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async updateInventoryTransactionStatus(params: TUpdateInventoryTransactionStatusAPIParams): GatewayResponse<null> {
        const { authToken, ...restOfUpdateInventoryTransactionStatusAPIParams } = params;
        const response: ApiResponse<null> = await this.api.put('/approval/updateInventoryTransactionStatus', restOfUpdateInventoryTransactionStatusAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async updateDiscountStatus(params: TUpdateDiscountStatusAPIParams): GatewayResponse<null> {
        const { authToken, ...restOfUpdatePendingDiscountStatusAPIParams } = params;
        const response: ApiResponse<null> = await this.api.put('/approval/updateDiscountStatus', restOfUpdatePendingDiscountStatusAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async updateProductStatus(params: TUpdateProductStatusAPIParams): GatewayResponse<null> {
        const { authToken, ...restOfUpdatePendingProductStatusAPIParams } = params;
        const response: ApiResponse<null> = await this.api.put('/approval/updateAdminSettingStatus', restOfUpdatePendingProductStatusAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async updateProjectStatus(params: TUpdateProjectStatusAPIParams): GatewayResponse<null> {
        const { authToken, ...restOfUpdatePendingProductStatusAPIParams } = params;
        const response: ApiResponse<null> = await this.api.put('/approval/updateProjectStatus', restOfUpdatePendingProductStatusAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async updateInventoryTransferStatus(params: TUpdateInventoryTransferStatusAPIParams): GatewayResponse<null> {
        const { authToken, ...restOfUpdatePendingProductStatusAPIParams } = params;
        const response: ApiResponse<null> = await this.api.put('/approval/updateInventoryTransferStatus', restOfUpdatePendingProductStatusAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async updateCollateralStatus(params: TUpdateCollateralStatusAPIParams): GatewayResponse<null> {
        const { authToken, ...restOfUpdatePendingCollateralStatusAPIParams } = params;
        const response: ApiResponse<null> = await this.api.put('/approval/updateCollateralStatus', restOfUpdatePendingCollateralStatusAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async updateReleaseEarmark(params: TUpdateReleaseEarmarkAPIParams): GatewayResponse<null> {
        const { authToken, ...body } = params;
        const response: ApiResponse<null> = await this.api.put('/approval/updateEarmarkReleaseStatus', body, getHeaders(authToken));
        return this.process(response);
    }

    async updateBranchStatus(params: TUpdateBranchStatusAPIParams): GatewayResponse<null> {
        const { authToken, ...body } = params;
        const response: ApiResponse<null> = await this.api.put('/approval/updateBranchStatus', body, getHeaders(authToken));
        return this.process(response);
    }

    async updateGoldConversionStatus(params: TUpdateGoldConversionStatusAPIParams): GatewayResponse<null> {
        const { authToken, ...body } = params;
        const response: ApiResponse<null> = await this.api.put('/approval/updateConversionStatus', body, getHeaders(authToken));
        return this.process(response);
    }

    async updateEarmarkConversionStatus(params: TUpdateEarmarkConversionStatusAPIParams): GatewayResponse<string | null> {
        const { authToken, ...restOfParams } = params;
        const response: ApiResponse<string | null> = await this.api.put(
            '/approval/updateEarmarkConversionStatus',
            { ...restOfParams },
            getHeaders(authToken)
        );
        return this.process(response);
    }

    async updateStockOutStatus(params: TUpdateStockOutStatusAPIParams): GatewayResponse<null> {
        const { authToken, ...body } = params;
        const response: ApiResponse<null> = await this.api.put('/approval/stockouts/status', body, getHeaders(authToken));
        return this.process(response);
    }

    async updateCustomerTransferStatus(params: TUpdateCustomerTransferStatusAPIParams): GatewayResponse<null> {
        const { authToken, ...body } = params;
        const response: ApiResponse<null> = await this.api.put('/approval/customer-transfers/status', body, getHeaders(authToken));
        return this.process(response);
    }
}
